var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaginationLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5111 4.4119V3.08621C12.5111 2.9713 12.379 2.90785 12.2899 2.97816L4.55863 9.01668C4.49294 9.06777 4.43979 9.13318 4.40322 9.20793C4.36666 9.28268 4.34766 9.36479 4.34766 9.44801C4.34766 9.53122 4.36666 9.61333 4.40322 9.68808C4.43979 9.76284 4.49294 9.82825 4.55863 9.87933L12.2899 15.9179C12.3808 15.9882 12.5111 15.9247 12.5111 15.8098V14.4841C12.5111 14.4001 12.4716 14.3195 12.4065 14.268L6.23247 9.44886L12.4065 4.62799C12.4716 4.57654 12.5111 4.49594 12.5111 4.4119V4.4119Z",
    fill: "black",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationLeft);
export default __webpack_public_path__ + "static/media/paginationLeft.78d23d60f05d676a7529f110cab62333.svg";
export { ForwardRef as ReactComponent };